export enum SupportedLanguages {
  English_US = "en",
  English_GB = "en_GB",
  Spanish = "es",
  Spanish_ES = "es_ES",
  Spanish_MX = "es_MX",
  Portuguese_PT = "pt_PT",
  Portuguese_BR = "pt_BR",
  Hebrew = "he",
  Chinese = "zh",
  Hindi = "hi",
  Arabic = "ar",
  Bengali = "bn",
  Russian = "ru",
  Japanese = "ja",
  Vietnamese = "vi",
  Korean = "ko",
  German = "de",
  French = "fr",
  Turkish = "tr",
  Italian = "it",
  Thai = "th",
  Tamil = "ta",
  Urdu = "ur",
  Persian = "fa",
  Ukrainian = "uk",
  Indonesian = "id",
  Malay = "ms",
  Dutch = "nl",
  Polish = "pl",
  Swedish = "sv",
  Greek = "el",
  Danish = "da",
  Norwegian = "no",
  Finnish = "fi",
  Czech = "cs",
  Hungarian = "hu",
  Romanian = "ro",
  Slovak = "sk",
  Bulgarian = "bg",
  Croatian = "hr",
  Irish = "ga",
  Estonian = "et",
  Latvian = "lv",
  Lithuanian = "lt",
  Maltese = "mt",
  Slovenian = "sl",
}

export const SupportedLanguagesNamesAndIcons = {
  en: {
    name: "English (US)",
    icon: "🇺🇸", // United States flag emoji
  },
  en_US: {
    name: "English (US)",
    icon: "🇺🇸", // United States flag emoji
  },
  en_GB: {
    name: "English (UK)",
    icon: "🇬🇧", // Great Britain flag emoji
  },
  es: {
    name: "Español (ES)",
    icon: "🇪🇸", // Spain flag emoji
  },
  es_ES: {
    name: "Español (ES)",
    icon: "🇪🇸", // Spain flag emoji
  },
  es_MX: {
    name: "Español (MX)",
    icon: "🇲🇽", // Mexico flag emoji
  },
  pt_PT: {
    name: "Português (PT)",
    icon: "🇵🇹", // Portugal flag emoji
  },
  pt_BR: {
    name: "Português (BR)",
    icon: "🇧🇷", // Brazil flag emoji
  },
  he: {
    name: "עִבְרִית",
    icon: "🇮🇱", // Israel flag emoji
  },
  zh: {
    name: "中文",
    icon: "🇨🇳", // China flag emoji
  },
  hi: {
    name: "हिन्दी",
    icon: "🇮🇳", // India flag emoji
  },
  ar: {
    name: "العربية",
    icon: "🇸🇦", // Saudi Arabia flag emoji
  },
  bn: {
    name: "বাংলা",
    icon: "🇧🇩", // Bangladesh flag emoji
  },
  ru: {
    name: "Русский",
    icon: "🇷🇺", // Russia flag emoji
  },
  ja: {
    name: "日本語",
    icon: "🇯🇵", // Japan flag emoji
  },
  vi: {
    name: "Tiếng Việt",
    icon: "🇻🇳", // Vietnam flag emoji
  },
  ko: {
    name: "한국어",
    icon: "🇰🇷", // South Korea flag emoji
  },
  de: {
    name: "Deutsch",
    icon: "🇩🇪", // Germany flag emoji
  },
  fr: {
    name: "Français",
    icon: "🇫🇷", // France flag emoji
  },
  tr: {
    name: "Türkçe",
    icon: "🇹🇷", // Turkey flag emoji
  },
  it: {
    name: "Italiano",
    icon: "🇮🇹", // Italy flag emoji
  },
  th: {
    name: "ไทย",
    icon: "🇹🇭", // Thailand flag emoji
  },
  ta: {
    name: "தமிழ்",
    icon: "🇮🇳", // India flag emoji (Tamil is also spoken in Sri Lanka)
  },
  ur: {
    name: "اردو",
    icon: "🇵🇰", // Pakistan flag emoji
  },
  fa: {
    name: "فارسی",
    icon: "🇮🇷", // Iran flag emoji
  },
  uk: {
    name: "Українська",
    icon: "🇺🇦", // Ukraine flag emoji
  },
  id: {
    name: "Bahasa Indonesia",
    icon: "🇮🇩", // Indonesia flag emoji
  },
  ms: {
    name: "Bahasa Melayu",
    icon: "🇲🇾", // Malaysia flag emoji
  },
  nl: {
    name: "Nederlands",
    icon: "🇳🇱", // Netherlands flag emoji
  },
  pl: {
    name: "Polski",
    icon: "🇵🇱", // Poland flag emoji
  },
  sv: {
    name: "Svenska",
    icon: "🇸🇪", // Sweden flag emoji
  },
  el: {
    name: "Ελληνικά",
    icon: "🇬🇷", // Greece flag emoji
  },
  da: {
    name: "Dansk",
    icon: "🇩🇰", // Denmark flag emoji
  },
  no: {
    name: "Norsk",
    icon: "🇳🇴", // Norway flag emoji
  },
  fi: {
    name: "Suomi",
    icon: "🇫🇮", // Finland flag emoji
  },
  cs: {
    name: "Čeština",
    icon: "🇨🇿", // Czech Republic flag emoji
  },
  hu: {
    name: "Magyar",
    icon: "🇭🇺", // Hungary flag emoji
  },
  ro: {
    name: "Română",
    icon: "🇷🇴", // Romania flag emoji
  },
  sk: {
    name: "Slovenčina",
    icon: "🇸🇰", // Slovakia flag emoji
  },
  bg: {
    name: "Български",
    icon: "🇧🇬", // Bulgaria flag emoji
  },
  hr: {
    name: "Hrvatski",
    icon: "🇭🇷", // Croatia flag emoji
  },
  ga: {
    name: "Gaeilge",
    icon: "🇮🇪", // Ireland flag emoji
  },
  et: {
    name: "Eesti",
    icon: "🇪🇪", // Estonia flag emoji
  },
  lv: {
    name: "Latviešu",
    icon: "🇱🇻", // Latvia flag emoji
  },
  lt: {
    name: "Lietuvių",
    icon: "🇱🇹", // Lithuania flag emoji
  },
  mt: {
    name: "Malti",
    icon: "🇲🇹", // Malta flag emoji
  },
  sl: {
    name: "Slovenščina",
    icon: "🇸🇮", // Slovenia flag emoji
  },
};

export const rtlLanguages = [SupportedLanguages.Hebrew, SupportedLanguages.Arabic, SupportedLanguages.Persian, SupportedLanguages.Urdu, SupportedLanguages.Bengali, SupportedLanguages.Tamil];
